import WorkflowApprovalDetail from './WorkflowApprovalDetail';

export default WorkflowApprovalDetail;
